export default {
    bindings: {
        'item': '=',
        'basket': '=',
        'status': '<',
        'gender': '@',
        'getQuantity': '&',
        'getAvailabilitySingle': '&'
    },
    controller: 'addButtonController',
    template: require('../views/addButton.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/addButton.component.js